export default __webpack_public_path__ + "static/screenshot-target-scores--mobile-9e5399d522fa8b1800eebe30061ee69f.png";